<template>
  <div class="contentPadding">
    <a-tabs v-model:activeKey="activeKey" :animated="false">
      <a-tab-pane key="1" tab="课程列表">
        <curriculum></curriculum>
      </a-tab-pane>
      <a-tab-pane key="2" tab="讲义列表" force-render>
        <handout></handout>
      </a-tab-pane>
      <a-tab-pane key="3" tab="视频列表">
        <videoAssembly></videoAssembly>
      </a-tab-pane>
      <a-tab-pane key="4" tab="课程类型">
        <courseType></courseType>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import curriculum from "./curriculum";
import handout from "./handout";
import videoAssembly from "./video";
import courseType from "./courseType";

const defaultform = {
  province: null,
  city: null,
  companyName: "",
  pageIndex: 1,
  pageSize: 10
};
export default {
  name: "",
  props: {},
  data() {
    return {
      certificateTypeList: null,
      fileCode: null,
      partnerlist: null,
      activeKey: "1"
    };
  },
  components: {
    curriculum,
    handout,
    videoAssembly,
    courseType
  },
  methods: {}
};
</script>
<style lang="scss" scoped></style>
